import {
  SsoQueryParamsTypes,
  SsoTypeTypes,
} from '~/components/SSO/utils/types';
import { STATUSES } from '~/utils/site/constants';

export interface SystemConsoleData {
  name: string;
  type: SsoTypeTypes;
  queryParams: SsoQueryParamsTypes;
}

export const APP_ACTION_PROGRESS_STATUS = [
  ...STATUSES.CREATING,
  ...STATUSES.DELETING,
  ...STATUSES.RESETTING,
];

export const VPS_MANAGEABLE_APPS = [
  'n8n',
  'wordpress',
  'portainer',
  'magento',
  'openclaw',
];

export const CHANGE_URL = 'change?installedApp=';
export const INSTALL_URL = 'install';
export const CHANGE_IMAGE = 'reimage';

// Statuses that indicate reimage is in progress
export const REIMAGE_IN_PROGRESS_STATUSES = [
  'pending_create',
  'create',
  'pending_build',
  'build',
  'postprov',
  'pending_postprov',
  'pending_rebuild',
  'rebuild',
];

// Failed reimage statuses
export const REIMAGE_FAILED_STATUSES = [
  'failed_create',
  'failed_build',
  'failed_postprov',
  'failed_rebuild',
];

// Disabled reimage button statuses
export const DISABLED_REIMAGE_STATUSES = [
  'decom',
  'stopped',
  'pending_start',
  'start',
  'pending_stop',
  'stop',
  'pending_reboot_soft',
  'reboot_soft',
  'deleted',
  ...REIMAGE_IN_PROGRESS_STATUSES,
];

export const DISABLE_LAUNCH_CONSOLE_ACTION = [
  'deleted',
  'pending_create',
  'create',
  'pending_build',
  'build',
  'pending_rebuild',
  'rebuild',
  'stopped',
  'pending_stop',
  'stop',
];

export const TERMINAL_LAUNCH_CONSOLE_ACTION = [
  ...DISABLE_LAUNCH_CONSOLE_ACTION,
  'pending_start',
  'start',
  'pending_reboot_soft',
  'reboot_soft',
];

// Polling configuration
export const POLL_INTERVAL = 10000; // Poll every 10 seconds
export const MAX_POLL_COUNT = 60; // Max 60 calls (10 minutes)
export const VPS_REIMAGE_ACTION_TYPE = 'rebuild';
export const OPEN_CLAW = 'openclaw';
export const CPANEL_APP = 'cPanel';

export const CPANEL = 'cpanel';
export const MAGENTO = 'magento';
export const GATOR_CLAW = 'gatorclaw';
export const NON_DOCKER_APPS = ['magento', 'cPanel', 'gatorclaw'];
export const VPS_NON_DOCKER_APPS = ['magento', 'gatorclaw'];

export const LICENSE_BLOCKED: readonly string[] = [
  'decom',
  'deleted',
  'disabled',
];

export const SUPPORTED_LICENSE_SUBTYPES = ['cPanel'];

export const systemConsoleData: SystemConsoleData = {
  name: 'console',
  type: 'vps',
  queryParams: {
    app: 'console',
  } as unknown as SsoQueryParamsTypes,
};

export const REIMAGE_ROUTE_TO_TAB_PATH = {
  'plain-os': 'reimage-server/plain-os',
  applications: 'reimage-server/applications',
} as const;

export type ReimageTab = keyof typeof REIMAGE_ROUTE_TO_TAB_PATH;

export const APP_IMAGE_TYPES = ['docker_app', 'app', 'cpanel'];

export const APPLICATION_SEARCH_FIELDS = ['app', 'software', 'title'] as const;
export const OS_SEARCH_FIELDS = ['os_name', 'title'] as const;
